export const updateSearchPage = async (param_name: string, value: string, to = null) => {
  const currentParams = new URLSearchParams(window.location.search);
  if(value == ""){
    currentParams.delete(param_name, value);
  }else{
    currentParams.set(param_name, value || "");
  }
  currentParams.set(param_name, value || "");
  if (param_name === "type" && value !== "product") {
    currentParams.delete("filter.p.m.filters.benefits");
    currentParams.delete("filter.p.m.filters.type");
    currentParams.delete("filter.p.tag");
  }
  const newurl = `${window.Shopify.routes.root}search?${currentParams.toString()}`;

  const response = await fetch(newurl).then((response) => response.text());

  const html = document.createElement('div');
  html.innerHTML = response;

  const newContent = html.querySelectorAll('[search-results]');

  history.replaceState({}, "", newurl);

  document.body.querySelectorAll('[search-results]').forEach((item, index) => {
    item.innerHTML = newContent[index].innerHTML;
  });

  if (to != null) {
    const element = document.querySelector(to);
    if (element) {
      element.scrollIntoView();
    }
  }
};
